import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import {ActivePlatformAlertsSortField as ActivePlatformAlertsSortFields} from '../typedef';

import type {ActivePlatformAlertsFilters, ActivePlatformAlertsSortField} from '../typedef';
import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';


export const activePlatformAlertsStateSlice = getCachedTableStateSlice<
    undefined,
    ActivePlatformAlertsSortField,
    ActivePlatformAlertsFilters
>('activePlatformAlertsState', ActivePlatformAlertsSortFields.ALERT_MESSAGE);

export const activePlatformAlertsStateActions = activePlatformAlertsStateSlice.actions;
export const activePlatformAlertsStateSelector:
CachedTableStateSelector<undefined, ActivePlatformAlertsSortField, ActivePlatformAlertsFilters> =
    state => state.platformAlertBuilder.state;
